import { render, staticRenderFns } from "./GroupHeader.vue?vue&type=template&id=a7a41d30&scoped=true"
import script from "./GroupHeader.vue?vue&type=script&lang=js"
export * from "./GroupHeader.vue?vue&type=script&lang=js"
import style0 from "./GroupHeader.vue?vue&type=style&index=0&id=a7a41d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a41d30",
  null
  
)

export default component.exports